<div class="dashboard-layout">
  <header class="dashboard-header">
    <div class="header-left">
      <button type="button" class="burger-btn" (click)="toggleSidebar()" [attr.aria-label]="sidebarOpen ? 'Close menu' : 'Open menu'" [attr.aria-expanded]="sidebarOpen">
        <i class="bi" [class.bi-x-lg]="sidebarOpen" [class.bi-list]="!sidebarOpen"></i>
      </button>
      <a routerLink="/admin" class="dashboard-title app-brand"><i class="bi bi-gear-wide-connected app-brand-icon"></i> Admin</a>
    </div>
    <div class="dashboard-header-actions">
      <a routerLink="/dashboard/my-profile" class="header-link"><i class="bi bi-person"></i> {{ userName }}</a>
      <span class="header-sep">|</span>
      <a routerLink="/logout" class="header-link logout-link">Logout</a>
    </div>
  </header>

  <div class="dashboard-body">
    @if (sidebarOpen) {
      <div class="sidebar-backdrop" (click)="closeSidebar()" role="button" tabindex="0" (keydown)="$event.key === 'Escape' && closeSidebar()"></div>
    }
    <aside class="dashboard-sidebar" [class.sidebar-open]="sidebarOpen">
      <nav class="sidebar-nav">
        <div class="sidebar-section">
          <a routerLink="/admin" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="sidebar-link">
            <i class="bi bi-house"></i>
            <span>Dashboard</span>
          </a>
        </div>
        <div class="sidebar-section">
          <div class="sidebar-section-header">CUSTOMERS</div>
          <a routerLink="/admin/users" routerLinkActive="active" class="sidebar-link">
            <i class="bi bi-people"></i>
            <span>Users</span>
          </a>
          <a routerLink="/admin/fraud" routerLinkActive="active" class="sidebar-link">
            <i class="bi bi-shield-exclamation"></i>
            <span>Fraud</span>
          </a>
          <a routerLink="/admin/messages" routerLinkActive="active" class="sidebar-link">
            <i class="bi bi-envelope"></i>
            <span>Messages</span>
          </a>
          <a routerLink="/admin/question-comments" routerLinkActive="active" class="sidebar-link">
            <i class="bi bi-chat-left-text"></i>
            <span>Comments</span>
          </a>
        </div>
        <div class="sidebar-section">
          <div class="sidebar-section-header">OFFERS</div>
          <a routerLink="/admin/content" routerLinkActive="active" class="sidebar-link">
            <i class="bi bi-collection"></i>
            <span>Content</span>
          </a>
          <a routerLink="/admin/subscriptions" routerLinkActive="active" class="sidebar-link">
            <i class="bi bi-credit-card"></i>
            <span>Subscriptions</span>
          </a>
        </div>
        <div class="sidebar-section">
          <div class="sidebar-section-header">SOCIAL</div>
          <a routerLink="/admin/social/analytics" routerLinkActive="active" class="sidebar-link">
            <i class="bi bi-graph-up"></i>
            <span>Analytics</span>
          </a>
          <a routerLink="/admin/social/templates" routerLinkActive="active" class="sidebar-link">
            <i class="bi bi-bell"></i>
            <span>Templates</span>
          </a>
        </div>
        <div class="sidebar-section">
          <div class="sidebar-section-header">MISC</div>
          <a routerLink="/admin/settings" routerLinkActive="active" class="sidebar-link">
            <i class="bi bi-gear"></i>
            <span>Settings</span>
          </a>
          <a routerLink="/admin/news" routerLinkActive="active" class="sidebar-link">
            <i class="bi bi-newspaper"></i>
            <span>News</span>
          </a>
        </div>
      </nav>
    </aside>

    <main class="dashboard-main">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
